/* eslint-disable */
import { Timestamp } from "../../../../google/protobuf/timestamp";

export const protobufPackage = "od_protos.journey.data.categories";

export interface AssessmentCategory {
  event?:
    | { $case: "flowStart"; flowStart: AssessmentCategory_AssessmentFlowStartEvent }
    | { $case: "flowCompleted"; flowCompleted: AssessmentCategory_AssessmentFlowCompletedEvent }
    | { $case: "requested"; requested: AssessmentCategory_AssessmentRequestedEvent }
    | { $case: "scheduleStart"; scheduleStart: AssessmentCategory_AssessmentScheduleStartEvent }
    | { $case: "firstPhotoTaken"; firstPhotoTaken: AssessmentCategory_AssessmentFirstPhotoTaken }
    | { $case: "firstQuestionAnswered"; firstQuestionAnswered: AssessmentCategory_AssessmentFirstQuestionAnswered }
    | { $case: "spaceCompleted"; spaceCompleted: AssessmentCategory_AssessmentSpaceCompleted }
    | undefined;
}

export enum AssessmentCategory_AssessmentType {
  UNKNOWN_ASSESSMENT_TYPE = 0,
  ORVA = 1,
  SSVA = 2,
  HA = 3,
  VIRTUAL_INSPECTION = 4,
  UNRECOGNIZED = -1,
}

export function assessmentCategory_AssessmentTypeFromJSON(object: any): AssessmentCategory_AssessmentType {
  switch (object) {
    case 0:
    case "UNKNOWN_ASSESSMENT_TYPE":
      return AssessmentCategory_AssessmentType.UNKNOWN_ASSESSMENT_TYPE;
    case 1:
    case "ORVA":
      return AssessmentCategory_AssessmentType.ORVA;
    case 2:
    case "SSVA":
      return AssessmentCategory_AssessmentType.SSVA;
    case 3:
    case "HA":
      return AssessmentCategory_AssessmentType.HA;
    case 4:
    case "VIRTUAL_INSPECTION":
      return AssessmentCategory_AssessmentType.VIRTUAL_INSPECTION;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AssessmentCategory_AssessmentType.UNRECOGNIZED;
  }
}

export function assessmentCategory_AssessmentTypeToJSON(object: AssessmentCategory_AssessmentType): string {
  switch (object) {
    case AssessmentCategory_AssessmentType.UNKNOWN_ASSESSMENT_TYPE:
      return "UNKNOWN_ASSESSMENT_TYPE";
    case AssessmentCategory_AssessmentType.ORVA:
      return "ORVA";
    case AssessmentCategory_AssessmentType.SSVA:
      return "SSVA";
    case AssessmentCategory_AssessmentType.HA:
      return "HA";
    case AssessmentCategory_AssessmentType.VIRTUAL_INSPECTION:
      return "VIRTUAL_INSPECTION";
    case AssessmentCategory_AssessmentType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface AssessmentCategory_AssessmentFlowStartEvent {
  /** @deprecated */
  leadId: string;
  offerUuid: string;
  assessmentType: AssessmentCategory_AssessmentType;
  sellerLeadUuid: string;
}

export interface AssessmentCategory_AssessmentFlowCompletedEvent {
  /** @deprecated */
  leadId: string;
  offerUuid: string;
  assessmentType: AssessmentCategory_AssessmentType;
  sellerLeadUuid: string;
}

export interface AssessmentCategory_AssessmentRequestedEvent {
  sellerLeadUuid: string;
  offerUuid: string;
  requestedDatetime?: Date | undefined;
}

export interface AssessmentCategory_AssessmentScheduleStartEvent {
  sellerLeadUuid: string;
  offerUuid: string;
  assessmentType: AssessmentCategory_AssessmentType;
}

export interface AssessmentCategory_AssessmentFirstPhotoTaken {
  sellerLeadUuid: string;
  offerUuid: string;
}

export interface AssessmentCategory_AssessmentFirstQuestionAnswered {
  sellerLeadUuid: string;
  offerUuid: string;
}

export interface AssessmentCategory_AssessmentSpaceCompleted {
  sellerLeadUuid: string;
  offerUuid: string;
  allAreasCompleted: boolean;
  spaceTypeName: string;
}

function createBaseAssessmentCategory(): AssessmentCategory {
  return { event: undefined };
}

export const AssessmentCategory = {
  fromJSON(object: any): AssessmentCategory {
    return {
      event: isSet(object.flowStart)
        ? { $case: "flowStart", flowStart: AssessmentCategory_AssessmentFlowStartEvent.fromJSON(object.flowStart) }
        : isSet(object.flowCompleted)
        ? {
          $case: "flowCompleted",
          flowCompleted: AssessmentCategory_AssessmentFlowCompletedEvent.fromJSON(object.flowCompleted),
        }
        : isSet(object.requested)
        ? { $case: "requested", requested: AssessmentCategory_AssessmentRequestedEvent.fromJSON(object.requested) }
        : isSet(object.scheduleStart)
        ? {
          $case: "scheduleStart",
          scheduleStart: AssessmentCategory_AssessmentScheduleStartEvent.fromJSON(object.scheduleStart),
        }
        : isSet(object.firstPhotoTaken)
        ? {
          $case: "firstPhotoTaken",
          firstPhotoTaken: AssessmentCategory_AssessmentFirstPhotoTaken.fromJSON(object.firstPhotoTaken),
        }
        : isSet(object.firstQuestionAnswered)
        ? {
          $case: "firstQuestionAnswered",
          firstQuestionAnswered: AssessmentCategory_AssessmentFirstQuestionAnswered.fromJSON(
            object.firstQuestionAnswered,
          ),
        }
        : isSet(object.spaceCompleted)
        ? {
          $case: "spaceCompleted",
          spaceCompleted: AssessmentCategory_AssessmentSpaceCompleted.fromJSON(object.spaceCompleted),
        }
        : undefined,
    };
  },

  toJSON(message: AssessmentCategory): unknown {
    const obj: any = {};
    if (message.event?.$case === "flowStart") {
      obj.flowStart = AssessmentCategory_AssessmentFlowStartEvent.toJSON(message.event.flowStart);
    }
    if (message.event?.$case === "flowCompleted") {
      obj.flowCompleted = AssessmentCategory_AssessmentFlowCompletedEvent.toJSON(message.event.flowCompleted);
    }
    if (message.event?.$case === "requested") {
      obj.requested = AssessmentCategory_AssessmentRequestedEvent.toJSON(message.event.requested);
    }
    if (message.event?.$case === "scheduleStart") {
      obj.scheduleStart = AssessmentCategory_AssessmentScheduleStartEvent.toJSON(message.event.scheduleStart);
    }
    if (message.event?.$case === "firstPhotoTaken") {
      obj.firstPhotoTaken = AssessmentCategory_AssessmentFirstPhotoTaken.toJSON(message.event.firstPhotoTaken);
    }
    if (message.event?.$case === "firstQuestionAnswered") {
      obj.firstQuestionAnswered = AssessmentCategory_AssessmentFirstQuestionAnswered.toJSON(
        message.event.firstQuestionAnswered,
      );
    }
    if (message.event?.$case === "spaceCompleted") {
      obj.spaceCompleted = AssessmentCategory_AssessmentSpaceCompleted.toJSON(message.event.spaceCompleted);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssessmentCategory>, I>>(base?: I): AssessmentCategory {
    return AssessmentCategory.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssessmentCategory>, I>>(object: I): AssessmentCategory {
    const message = createBaseAssessmentCategory();
    if (
      object.event?.$case === "flowStart" && object.event?.flowStart !== undefined && object.event?.flowStart !== null
    ) {
      message.event = {
        $case: "flowStart",
        flowStart: AssessmentCategory_AssessmentFlowStartEvent.fromPartial(object.event.flowStart),
      };
    }
    if (
      object.event?.$case === "flowCompleted" &&
      object.event?.flowCompleted !== undefined &&
      object.event?.flowCompleted !== null
    ) {
      message.event = {
        $case: "flowCompleted",
        flowCompleted: AssessmentCategory_AssessmentFlowCompletedEvent.fromPartial(object.event.flowCompleted),
      };
    }
    if (
      object.event?.$case === "requested" && object.event?.requested !== undefined && object.event?.requested !== null
    ) {
      message.event = {
        $case: "requested",
        requested: AssessmentCategory_AssessmentRequestedEvent.fromPartial(object.event.requested),
      };
    }
    if (
      object.event?.$case === "scheduleStart" &&
      object.event?.scheduleStart !== undefined &&
      object.event?.scheduleStart !== null
    ) {
      message.event = {
        $case: "scheduleStart",
        scheduleStart: AssessmentCategory_AssessmentScheduleStartEvent.fromPartial(object.event.scheduleStart),
      };
    }
    if (
      object.event?.$case === "firstPhotoTaken" &&
      object.event?.firstPhotoTaken !== undefined &&
      object.event?.firstPhotoTaken !== null
    ) {
      message.event = {
        $case: "firstPhotoTaken",
        firstPhotoTaken: AssessmentCategory_AssessmentFirstPhotoTaken.fromPartial(object.event.firstPhotoTaken),
      };
    }
    if (
      object.event?.$case === "firstQuestionAnswered" &&
      object.event?.firstQuestionAnswered !== undefined &&
      object.event?.firstQuestionAnswered !== null
    ) {
      message.event = {
        $case: "firstQuestionAnswered",
        firstQuestionAnswered: AssessmentCategory_AssessmentFirstQuestionAnswered.fromPartial(
          object.event.firstQuestionAnswered,
        ),
      };
    }
    if (
      object.event?.$case === "spaceCompleted" &&
      object.event?.spaceCompleted !== undefined &&
      object.event?.spaceCompleted !== null
    ) {
      message.event = {
        $case: "spaceCompleted",
        spaceCompleted: AssessmentCategory_AssessmentSpaceCompleted.fromPartial(object.event.spaceCompleted),
      };
    }
    return message;
  },
};

function createBaseAssessmentCategory_AssessmentFlowStartEvent(): AssessmentCategory_AssessmentFlowStartEvent {
  return { leadId: "", offerUuid: "", assessmentType: 0, sellerLeadUuid: "" };
}

export const AssessmentCategory_AssessmentFlowStartEvent = {
  fromJSON(object: any): AssessmentCategory_AssessmentFlowStartEvent {
    return {
      leadId: isSet(object.leadId) ? String(object.leadId) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      assessmentType: isSet(object.assessmentType)
        ? assessmentCategory_AssessmentTypeFromJSON(object.assessmentType)
        : 0,
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
    };
  },

  toJSON(message: AssessmentCategory_AssessmentFlowStartEvent): unknown {
    const obj: any = {};
    if (message.leadId !== "") {
      obj.leadId = message.leadId;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.assessmentType !== 0) {
      obj.assessmentType = assessmentCategory_AssessmentTypeToJSON(message.assessmentType);
    }
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssessmentCategory_AssessmentFlowStartEvent>, I>>(
    base?: I,
  ): AssessmentCategory_AssessmentFlowStartEvent {
    return AssessmentCategory_AssessmentFlowStartEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssessmentCategory_AssessmentFlowStartEvent>, I>>(
    object: I,
  ): AssessmentCategory_AssessmentFlowStartEvent {
    const message = createBaseAssessmentCategory_AssessmentFlowStartEvent();
    message.leadId = object.leadId ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.assessmentType = object.assessmentType ?? 0;
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    return message;
  },
};

function createBaseAssessmentCategory_AssessmentFlowCompletedEvent(): AssessmentCategory_AssessmentFlowCompletedEvent {
  return { leadId: "", offerUuid: "", assessmentType: 0, sellerLeadUuid: "" };
}

export const AssessmentCategory_AssessmentFlowCompletedEvent = {
  fromJSON(object: any): AssessmentCategory_AssessmentFlowCompletedEvent {
    return {
      leadId: isSet(object.leadId) ? String(object.leadId) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      assessmentType: isSet(object.assessmentType)
        ? assessmentCategory_AssessmentTypeFromJSON(object.assessmentType)
        : 0,
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
    };
  },

  toJSON(message: AssessmentCategory_AssessmentFlowCompletedEvent): unknown {
    const obj: any = {};
    if (message.leadId !== "") {
      obj.leadId = message.leadId;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.assessmentType !== 0) {
      obj.assessmentType = assessmentCategory_AssessmentTypeToJSON(message.assessmentType);
    }
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssessmentCategory_AssessmentFlowCompletedEvent>, I>>(
    base?: I,
  ): AssessmentCategory_AssessmentFlowCompletedEvent {
    return AssessmentCategory_AssessmentFlowCompletedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssessmentCategory_AssessmentFlowCompletedEvent>, I>>(
    object: I,
  ): AssessmentCategory_AssessmentFlowCompletedEvent {
    const message = createBaseAssessmentCategory_AssessmentFlowCompletedEvent();
    message.leadId = object.leadId ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.assessmentType = object.assessmentType ?? 0;
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    return message;
  },
};

function createBaseAssessmentCategory_AssessmentRequestedEvent(): AssessmentCategory_AssessmentRequestedEvent {
  return { sellerLeadUuid: "", offerUuid: "", requestedDatetime: undefined };
}

export const AssessmentCategory_AssessmentRequestedEvent = {
  fromJSON(object: any): AssessmentCategory_AssessmentRequestedEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      requestedDatetime: isSet(object.requestedDatetime) ? fromJsonTimestamp(object.requestedDatetime) : undefined,
    };
  },

  toJSON(message: AssessmentCategory_AssessmentRequestedEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.requestedDatetime !== undefined) {
      obj.requestedDatetime = message.requestedDatetime.toISOString();
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssessmentCategory_AssessmentRequestedEvent>, I>>(
    base?: I,
  ): AssessmentCategory_AssessmentRequestedEvent {
    return AssessmentCategory_AssessmentRequestedEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssessmentCategory_AssessmentRequestedEvent>, I>>(
    object: I,
  ): AssessmentCategory_AssessmentRequestedEvent {
    const message = createBaseAssessmentCategory_AssessmentRequestedEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.requestedDatetime = object.requestedDatetime ?? undefined;
    return message;
  },
};

function createBaseAssessmentCategory_AssessmentScheduleStartEvent(): AssessmentCategory_AssessmentScheduleStartEvent {
  return { sellerLeadUuid: "", offerUuid: "", assessmentType: 0 };
}

export const AssessmentCategory_AssessmentScheduleStartEvent = {
  fromJSON(object: any): AssessmentCategory_AssessmentScheduleStartEvent {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      assessmentType: isSet(object.assessmentType)
        ? assessmentCategory_AssessmentTypeFromJSON(object.assessmentType)
        : 0,
    };
  },

  toJSON(message: AssessmentCategory_AssessmentScheduleStartEvent): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.assessmentType !== 0) {
      obj.assessmentType = assessmentCategory_AssessmentTypeToJSON(message.assessmentType);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssessmentCategory_AssessmentScheduleStartEvent>, I>>(
    base?: I,
  ): AssessmentCategory_AssessmentScheduleStartEvent {
    return AssessmentCategory_AssessmentScheduleStartEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssessmentCategory_AssessmentScheduleStartEvent>, I>>(
    object: I,
  ): AssessmentCategory_AssessmentScheduleStartEvent {
    const message = createBaseAssessmentCategory_AssessmentScheduleStartEvent();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.assessmentType = object.assessmentType ?? 0;
    return message;
  },
};

function createBaseAssessmentCategory_AssessmentFirstPhotoTaken(): AssessmentCategory_AssessmentFirstPhotoTaken {
  return { sellerLeadUuid: "", offerUuid: "" };
}

export const AssessmentCategory_AssessmentFirstPhotoTaken = {
  fromJSON(object: any): AssessmentCategory_AssessmentFirstPhotoTaken {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
    };
  },

  toJSON(message: AssessmentCategory_AssessmentFirstPhotoTaken): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssessmentCategory_AssessmentFirstPhotoTaken>, I>>(
    base?: I,
  ): AssessmentCategory_AssessmentFirstPhotoTaken {
    return AssessmentCategory_AssessmentFirstPhotoTaken.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssessmentCategory_AssessmentFirstPhotoTaken>, I>>(
    object: I,
  ): AssessmentCategory_AssessmentFirstPhotoTaken {
    const message = createBaseAssessmentCategory_AssessmentFirstPhotoTaken();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    return message;
  },
};

function createBaseAssessmentCategory_AssessmentFirstQuestionAnswered(): AssessmentCategory_AssessmentFirstQuestionAnswered {
  return { sellerLeadUuid: "", offerUuid: "" };
}

export const AssessmentCategory_AssessmentFirstQuestionAnswered = {
  fromJSON(object: any): AssessmentCategory_AssessmentFirstQuestionAnswered {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
    };
  },

  toJSON(message: AssessmentCategory_AssessmentFirstQuestionAnswered): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssessmentCategory_AssessmentFirstQuestionAnswered>, I>>(
    base?: I,
  ): AssessmentCategory_AssessmentFirstQuestionAnswered {
    return AssessmentCategory_AssessmentFirstQuestionAnswered.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssessmentCategory_AssessmentFirstQuestionAnswered>, I>>(
    object: I,
  ): AssessmentCategory_AssessmentFirstQuestionAnswered {
    const message = createBaseAssessmentCategory_AssessmentFirstQuestionAnswered();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    return message;
  },
};

function createBaseAssessmentCategory_AssessmentSpaceCompleted(): AssessmentCategory_AssessmentSpaceCompleted {
  return { sellerLeadUuid: "", offerUuid: "", allAreasCompleted: false, spaceTypeName: "" };
}

export const AssessmentCategory_AssessmentSpaceCompleted = {
  fromJSON(object: any): AssessmentCategory_AssessmentSpaceCompleted {
    return {
      sellerLeadUuid: isSet(object.sellerLeadUuid) ? String(object.sellerLeadUuid) : "",
      offerUuid: isSet(object.offerUuid) ? String(object.offerUuid) : "",
      allAreasCompleted: isSet(object.allAreasCompleted) ? Boolean(object.allAreasCompleted) : false,
      spaceTypeName: isSet(object.spaceTypeName) ? String(object.spaceTypeName) : "",
    };
  },

  toJSON(message: AssessmentCategory_AssessmentSpaceCompleted): unknown {
    const obj: any = {};
    if (message.sellerLeadUuid !== "") {
      obj.sellerLeadUuid = message.sellerLeadUuid;
    }
    if (message.offerUuid !== "") {
      obj.offerUuid = message.offerUuid;
    }
    if (message.allAreasCompleted === true) {
      obj.allAreasCompleted = message.allAreasCompleted;
    }
    if (message.spaceTypeName !== "") {
      obj.spaceTypeName = message.spaceTypeName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssessmentCategory_AssessmentSpaceCompleted>, I>>(
    base?: I,
  ): AssessmentCategory_AssessmentSpaceCompleted {
    return AssessmentCategory_AssessmentSpaceCompleted.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssessmentCategory_AssessmentSpaceCompleted>, I>>(
    object: I,
  ): AssessmentCategory_AssessmentSpaceCompleted {
    const message = createBaseAssessmentCategory_AssessmentSpaceCompleted();
    message.sellerLeadUuid = object.sellerLeadUuid ?? "";
    message.offerUuid = object.offerUuid ?? "";
    message.allAreasCompleted = object.allAreasCompleted ?? false;
    message.spaceTypeName = object.spaceTypeName ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string } ? { [K in keyof Omit<T, "$case">]?: DeepPartial<T[K]> } & { $case: T["$case"] }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
